import { createRoute } from "@tanstack/react-router";
import { LegalPlaceholderGuard } from "@/components/LegalPlaceholderGuard";
import { rootRoute } from "./__root";

function ImpressumPage() {
  return (
    <div className="min-h-screen bg-bg">
      <div className="mx-auto max-w-2xl px-6 py-12 space-y-8">
        <a
          href="/"
          className="inline-flex items-center gap-1.5 text-sm text-text-muted hover:text-accent transition-colors"
        >
          <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m15 18-6-6 6-6" />
          </svg>
          Zurück
        </a>

        <LegalPlaceholderGuard className="space-y-8">
          <h1 className="text-3xl font-bold tracking-tight text-text">Impressum</h1>

          <section className="space-y-2 text-sm text-text-muted leading-relaxed">
            <h2 className="text-base font-semibold text-text">Angaben gemäß § 5 DDG</h2>
            <p>
              [DEIN VORNAME NACHNAME]<br />
              [STRASSE HAUSNUMMER]<br />
              [PLZ ORT]<br />
              Deutschland
            </p>
          </section>

          <section className="space-y-2 text-sm text-text-muted leading-relaxed">
            <h2 className="text-base font-semibold text-text">Kontakt</h2>
            <p>
              E-Mail:{" "}
              <a href="mailto:support@takelead.app" className="text-accent hover:underline">
                support@takelead.app
              </a>
            </p>
          </section>

          <section className="space-y-2 text-sm text-text-muted leading-relaxed">
            <h2 className="text-base font-semibold text-text">Umsatzsteuer</h2>
            <p>
              Gemäß § 19 UStG wird keine Umsatzsteuer berechnet (Kleinunternehmerregelung).
            </p>
          </section>

          <section className="space-y-2 text-sm text-text-muted leading-relaxed">
            <h2 className="text-base font-semibold text-text">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p>
              [DEIN VORNAME NACHNAME]<br />
              [STRASSE HAUSNUMMER]<br />
              [PLZ ORT]
            </p>
          </section>

          <section className="space-y-2 text-sm text-text-muted leading-relaxed">
            <h2 className="text-base font-semibold text-text">EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-accent hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <p className="text-xs text-text-subtle pt-4">
            Letzte Aktualisierung: {new Date().toLocaleDateString("de-DE")}
          </p>
        </LegalPlaceholderGuard>
      </div>
    </div>
  );
}

export const impressumRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/impressum",
  component: ImpressumPage,
});
